import changelogData from '../content/changelog.json';

export interface ChangelogEntry {
  version: string;
  date: string;
  content: string;
}

export const getChangelogEntries = (): ChangelogEntry[] => {
  return changelogData.entries.sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );
}; 